import { useState } from 'react';
import { ConnectionFailed } from './ConnectionFailed/ConnectionFailed';
import { ConnectionModal } from './ConnectionModal/ConnectionModal';
import { ConnectionSuccess } from './ConnectionSuccess/ConnectionSuccess';
import { useAppStateContext } from '../../AppStateProvider/AppStateProvider';
import { getConnectivityStatus } from '../../../utils';

export function Connectivity() {
  const { state } = useAppStateContext();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const connectivityStatus = getConnectivityStatus(state.networkTestResult, state.conferencingStatusError);

  return (
    <>
      <ConnectionModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        serviceStatuses={state.twilioStatus}
        conferencingStatus={state.conferencingStatus}
        signalingGateway={connectivityStatus.signalingGateway}
      />
      {connectivityStatus.passed ? (
        <ConnectionSuccess openModal={() => setIsModalOpen(true)} />
      ) : (
        <ConnectionFailed openModal={() => setIsModalOpen(true)} />
      )}
    </>
  );
}
